export default __webpack_public_path__ + "static/media/triangle_down.ac445bb8.svg";